function isMobilePlp() {
  const { body } = document;

  if (!body || !window.matchMedia) {
    return false;
  }

  return (
    /(^|\s)template-collection/.test(body.className) &&
    window.matchMedia('(max-width: 767px)').matches
  );
}

function applyFreshchatVisibility() {
  if (!window.fcWidget) {
    return;
  }

  if (isMobilePlp()) {
    window.fcWidget.hide();
    return;
  }

  window.fcWidget.show();
}

window.applyFreshchatVisibility = applyFreshchatVisibility;

function initFreshChat() {
  window.fcWidget.init({
    token: '6615bfd5-460c-4244-be5d-63b818283059',
    host: 'https://fashionsociety2.freshchat.com',
    tags: ['zeb'],
  });

  applyFreshchatVisibility();
}

function initialize(doc, scriptId) {
  if (doc.getElementById(scriptId)) {
    initFreshChat();
    return;
  }

  const scriptEl = doc.createElement('script');
  scriptEl.id = scriptId;
  scriptEl.async = true;
  scriptEl.src = 'https://fashionsociety2.freshchat.com/js/widget.js';
  scriptEl.onload = initFreshChat;
  doc.head.appendChild(scriptEl);
}

function initiateCall() {
  initialize(document, 'Freshchat-js-sdk');
}

if (window.addEventListener) {
  window.addEventListener('load', initiateCall, false);
  window.addEventListener('resize', applyFreshchatVisibility, false);
  document.addEventListener('visibilitychange', applyFreshchatVisibility, false);
} else {
  window.attachEvent('onload', initiateCall);
}
